import { render, staticRenderFns } from "./CardSummary.vue?vue&type=template&id=16503bf5"
import script from "./CardSummary.vue?vue&type=script&lang=js"
export * from "./CardSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports